export function maxNumToBeAllowed(event, maxLen) {
    if (event.target.value.length >= maxLen) {
        return false;
    }
    return true;
}